<template>
  <mu-card id="nutrition-input">
    <mu-card-text class="card-style" v-bind:class="{cardHasData: hasData}">
      <div v-if="loading">
        <mu-flexbox class="card-loading-padding" align="center" justify="center">
          <mu-flexbox-item align="center">
            <mu-circular-progress :size="56" color="#FFFFFF" :strokeWidth="5"/>
          </mu-flexbox-item>
        </mu-flexbox>
      </div>
      <div v-if="!loading" class="animated fadeIn pointer" @click="goToDetail">
        <mu-flexbox v-if="!hasData" class="card-error-padding" justify="center">
          <mu-flexbox-item align="center">
            <div class="card-notice-title">{{$t('message.cardNutritionEmpty')}}</div>
            <div>{{$t('message.cardTapPrefix')}}
              <mu-icon class="card-icon-error" :size="16" slot="left" value="add"/>
              <span>{{$t('message.cardNutritionSubLine')}}</span>
            </div>
          </mu-flexbox-item>
        </mu-flexbox>
        <div v-else @click="goToDetail" style="cursor: pointer">
          <span v-show="false">{{hasData = true}}</span>
          <mu-content-block>
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title">{{$t('message.nutrientCarbohydrate')}}</mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div class="card-large-stat">
                  <span v-text="data.total_carbohydrate + 'g'"></span>
                </div>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>
          <mu-content-block>
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title">{{$t('message.nutrientProtein')}}</mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div v-text="data.total_protein + 'g'"/>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>
          <mu-content-block>
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title">{{$t('message.nutrientFat')}}</mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div v-text="data.total_fat + 'g'"/>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>
          <mu-content-block>
            <mu-flexbox>
              <mu-flexbox-item class="card-lite-title">{{$t('message.nutrientCalories')}}</mu-flexbox-item>
              <mu-flexbox-item align="right">
                <div v-text="data.total_calories + 'kcal'"/>
              </mu-flexbox-item>
            </mu-flexbox>
          </mu-content-block>
        </div>
      </div>
    </mu-card-text>
    <mu-card-actions>
      <mu-flexbox justify="flex_start" style="height: 48px">
        <svg class="card-left-icon" width="16px" height="16px" viewBox="26 191 14 17" version="1.1"
             xmlns="http://www.w3.org/2000/svg">
          <!-- Generator: Sketch 40.3 (33839) - http://www.bohemiancoding.com/sketch -->
          <desc>Created with Sketch.</desc>
          <defs></defs>
          <g id="Group-4" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"
             transform="translate(26.000000, 191.000000)">
            <path
              d="M7.66316596,4.72800156 C7.06563404,4.87701832 6.44003404,4.87701832 5.84250213,4.72800156 C2.73012766,3.95229786 0.12413617,4.24974815 0.154229787,10.1646347 C0.169565957,13.194545 2.98505532,17.1232218 5.94406809,16.4510425 C6.47475745,16.3306043 7.03062128,16.3306043 7.56131064,16.4510425 C10.5203234,17.1232218 13.3358128,13.194545 13.3511489,10.1646347 C13.3812426,4.25003977 10.7755404,3.95229786 7.66316596,4.72800156 L7.66316596,4.72800156 Z"
              id="Shape" fill="#89C93B"></path>
            <path
              d="M1.6010383,8.65347057 C1.44102128,8.65347057 1.3116766,8.52282573 1.3116766,8.36185263 C1.3116766,6.75387135 2.47982979,5.44567329 3.91593191,5.44567329 C4.07594894,5.44567329 4.20529362,5.57631813 4.20529362,5.73729123 C4.20529362,5.89826433 4.07594894,6.02890916 3.91593191,6.02890916 C2.79928511,6.02890916 1.8904,7.07552593 1.8904,8.36185263 C1.8904,8.52282573 1.76076596,8.65347057 1.6010383,8.65347057 L1.6010383,8.65347057 Z"
              id="Shape" fill="#89C93B"></path>
            <path
              d="M6.732,5.83206706 C6.57661277,5.83206706 6.44813617,5.7075462 6.44321702,5.5497809 C6.40415319,4.3156538 5.93365106,2.76628772 4.72961702,2.11918752 C4.58869787,2.04336686 4.53516596,1.86693801 4.6104,1.72462846 C4.6859234,1.58261053 4.86040851,1.52866121 5.00219574,1.60448187 C6.42411915,2.36852086 6.97766809,4.13368421 7.02165106,5.53111735 C7.02685957,5.69209045 6.90156596,5.82681793 6.74154894,5.83177544 C6.7380766,5.83206706 6.73518298,5.83206706 6.732,5.83206706 L6.732,5.83206706 Z"
              id="Shape" fill="#89C93B"></path>
            <path
              d="M6.70624681,6.87985029 C6.22011915,6.87985029 5.7626383,6.68884055 5.41858723,6.3418152 C5.30544681,6.22808421 5.30544681,6.04349006 5.41858723,5.92946745 C5.53172766,5.81544483 5.71460426,5.81544483 5.82774468,5.92946745 C6.06270638,6.16626121 6.37492766,6.29661442 6.70624681,6.29661442 C7.03756596,6.29661442 7.34978723,6.16626121 7.58445957,5.92946745 C7.6976,5.81544483 7.8804766,5.81544483 7.99361702,5.92946745 C8.10675745,6.04319844 8.10675745,6.22779259 7.99361702,6.3418152 C7.64956596,6.68884055 7.19237447,6.87985029 6.70624681,6.87985029 L6.70624681,6.87985029 Z"
              id="Shape" fill="#89C93B"></path>
            <path
              d="M6.45421277,3.80269786 L6.63043404,2.61114698 C6.81649362,1.35281559 7.79685106,0.364814035 9.04544681,0.177303704 L10.2274894,0 L10.0512681,1.19155088 C9.86520851,2.44988226 8.88485106,3.43788382 7.63625532,3.62539415 L6.45421277,3.80269786 L6.45421277,3.80269786 Z"
              id="Shape" fill="#89C93B"></path>
          </g>
        </svg>
        <mu-flexbox-item class="left16" v-text="loading ? $t('message.loadingText') : title"></mu-flexbox-item>
        <mu-flexbox-item align="right">
          <mu-icon-button
            :disabled="loading"
            @click.native="goToDetail"
            class="card-bar-icon"
            :icon="'add'"
          ></mu-icon-button>
        </mu-flexbox-item>
      </mu-flexbox>
    </mu-card-actions>
  </mu-card>
</template>
<script>

  import { TweenMax, TweenLite, Power3, ScrollToPlugin } from 'gsap/all'
  import 'gsap/ScrollToPlugin'
  const plugins = [ ScrollToPlugin];

  import NutritionApi from '../../../../api/Tracking/Nutrition'
  import ScrollerMixin from '../../../../mixins/ScrollerMixin'

  export default {
    name: 'nutrition-input',
    mixins: [ScrollerMixin],
    data() {
      return {
        title: this.$t('message.cardNutrition'),
        isBackgroundShown: true,
        hasData: false,
        noData: true,
        loading: true,
        data: {},
      }
    },
    mounted() {
      let self = this;
      self.loadData();
    },
    methods: {
      loadData() {
        let self = this;
        self.loading = true;
        self.isOpenInput = false;
        self.model = {};

        NutritionApi.getNutritionCard()
          .then(function (response) {
            const status = response.status;
            if (status === 200) {
              self.hasData = true;
              self.data = response.data;
              self.$store.commit('setNutritionCard', response.data);
              self.loading = false
            }
            else {
              if (status === 201) {
                self.hasData = false;
                self.data = response.data;
                self.loading = false
              }
            }
          })

      },
      goToDetail() {
        let self = this;
        self.$router.push({
          path: '/food-diary'
        })
      }
    }
  }
</script>
<style lang="less">
  @import "nutrition.less";
</style>



// WEBPACK FOOTER //
// Nutrition.vue?7ef8ea2f